import { TranslationNS } from '@/i18n/TranslationKeys.ts';
import { TKeys } from '@/i18n/useTranslate.ts';
import i18n from './i18n';

export const getTranslate = async <T extends TranslationNS>(ns: T) => {
  if (ns !== 'common' || ns !== 'validationErrors') {
    await i18n.loadNamespaces(ns);
  }
  return (key: TKeys<T>, params?: Record<string, string | number>) =>
    i18n.t(key as string, { ns, ...params });
};
